import { render, staticRenderFns } from "./welcome-login.vue?vue&type=template&id=6e29f857&scoped=true"
import script from "./welcome-login.vue?vue&type=script&lang=js"
export * from "./welcome-login.vue?vue&type=script&lang=js"
import style0 from "./welcome-login.vue?vue&type=style&index=0&id=6e29f857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e29f857",
  null
  
)

export default component.exports